<template>
  <!-- The Modal -->
  <div
      id="editModal"
      class="modal"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <button
              type="button"
              class="close"
              data-dismiss="modal"
          >
            &times;
          </button>
        </div>
        <!-- Modal body -->
        <div class="">
          <!--Start-->
          <b-card-code
              title="Edit News"
          >
            <!-- form -->
            <validation-observer ref="simpleRules">
              <b-form>
                <b-row>
                  <b-col md="6">
                    <b-form-group>
                      <label for="name_en">Title «<span class="text-muted">English</span>»</label>
                      <validation-provider
                          #default="{ errors }"
                          name="Title En"
                          rules="required"
                      >
                        <b-form-input
                            id="name_en"
                            v-model="updatedNews.title"
                            name="name_en"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <label for="title_ar">Title «<span class="text-muted">Arabic</span>»</label>
                      <validation-provider
                          #default="{ errors }"
                          name="Title Ar"
                          rules="required"
                      >
                        <b-form-input
                            id="title_ar"
                            v-model="updatedNews.titleAR"
                            class="arabic-font"
                            name="title_ar"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                            :dir="'rtl'"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label for="contentEn">Content «<span class="text-muted">English</span>»</label>
                      <validation-provider
                          #default="{ errors }"
                          name="Content En"
                          rules="required"
                      >
                        <template>
                          <b-form-textarea
                              id="contentEn"
                              v-model="updatedNews.content"
                              :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                              placeholder=""
                              rows="5"
                              cols="12"
                          />
                        </template>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="content_ar">Content «<span class="text-muted">Arabic</span>»</label>
                      <validation-provider
                          id="contentAR"
                          #default="{ errors }"
                          name="Content Ar"
                          rules="required"
                          :dir="'rtl'"
                      >
                        <template>
                          <b-form-textarea
                              id="contentAR"
                              v-model="updatedNews.contentAR"
                              class="arabic-font"
                              :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                              placeholder=""
                              rows="5"
                              cols="12"
                          />
                        </template>

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="date">Date</label>
                      <validation-provider
                          #default="{ errors }"
                          name="date"
                          rules="required"
                      >
                        <template>
                          <b-form-datepicker
                              id="date"
                              v-model="updatedNews.date"
                              menu-class="w-100"
                              calendar-width="100%"
                          />
                        </template>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="cover">Cover</label>
                      <validation-provider
                          id="cover"
                          #default="{ errors }"
                          name="cover"
                          rules=""
                      >
                        <vue-dropzone
                            id="image"
                            ref="editNewsDropzone"
                            name="image"
                            :options="dropzoneOptions"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                </b-row>
                <!-- Modal footer -->
                <div class="modal-footer">
                  <button
                      type="button"
                      class="btn btn-primary"
                      @click.prevent="validationForm"
                  >
                    Submit
                  </button>
                </div>
              </b-form>
            </validation-observer>

            <template #code>
              {{ codeMultiple }}
            </template>
          </b-card-code>
          <!--End-->
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BFormTextarea, BFormDatepicker, BCardText,
} from 'bootstrap-vue'
import {
  required, email, confirmed, password,
} from '@validations'
import vue2Dropzone from 'vue2-dropzone'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import {codeMultiple, codeBasic} from './code'
import newsService from '@/services/newsService'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BFormDatepicker,
    BCardText,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BFormTextarea,
    vueDropzone: vue2Dropzone,
  },
  props: ['news'],
  data() {
    return {
      updatedNews: {
        id: '',
        title: '',
        titleAR: '',
        content: '',
        contentAR: '',
        cover: '',
        date: '',
      },
      emailValue: '',
      previousImages: [],
      PasswordValue: '',
      passwordCon: '',
      required,
      password,
      email,
      confirmed,
      codeMultiple,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        addRemoveLinks: true,
        acceptedFiles: ".jpeg,.jpg,.png,.gif",
        dictRemoveFile: 'Remove',
        maxFiles: 1
      },
      edited_service: {name: '', description: ''},
      codeBasic,
      selected: {title: 'Square'},
      option: [{title: 'Square'}, {title: 'Rectangle'}, {title: 'Rombo'}, {title: 'Romboid'}],
    }
  },
  mounted() {
    // this.previousImages = [
    //   { id: 1, url: 'https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__480.jpg', file: { size: 123, name: '', type: 'image/png' } },
    // ]
    // const { file } = this.previousImages[0]
    // const { url } = this.previousImages[0]
    //
    // this.$refs.myVueDropzone.manuallyAddFile(file, url)
    this.$watch(() => this.news, val => {
      /* Init Updated Object (Which will be sent To API) */
      /* Init Drop Zone */
      this.$refs.editNewsDropzone.removeAllFiles()
      this.$refs.editNewsDropzone.manuallyAddFile(val.cover.file, val.cover.url)

      /* Init Select2 */
      this.updatedNews = {
        id: val.id,
        title: val.title,
        titleAR: val.titleAR,
        content: val.content,
        contentAR: val.contentAR,
        cover: '',
        date: val.date,
      }
    })
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          // eslint-disable-next-line
          this.updatedNews.cover = this.$refs.editNewsDropzone.getAcceptedFiles()[0] ?? ''
          if (this.$refs.editNewsDropzone.getAcceptedFiles().length === 0) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Warning',
                icon: 'fas fa-rocket',
                variant: 'warning',
                text: 'Cover image is missing !',
              },
            })

          } else
            newsService.put(this.updatedNews).then(response => {

              if (response && response.status === 200) {
                this.$emit('refresh', 'true')
                this.updatedNews = {
                  id: '',
                  title: '',
                  titleAR: '',
                  content: '',
                  contentAR: '',
                  cover: '',
                  date: '',
                }
                this.$refs.editNewsDropzone.removeAllFiles()

                $('#editModal').modal('hide')
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Success',
                    icon: 'CheckIcon',
                    variant: 'success',
                    text: 'Service Is Updated Successfully !',
                  },
                })
              }
              this.loading = false
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

label {
  font-weight: bold;
}
</style>
